import { render, staticRenderFns } from "./userBalance.vue?vue&type=template&id=e7df0e04&scoped=true&"
import script from "./userBalance.vue?vue&type=script&lang=js&"
export * from "./userBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7df0e04",
  null
  
)

export default component.exports